import React from "react";
import classes from "./Spinner.module.css";

function Spinner() {
  return <div className={classes.Spinner}></div>;
}

export default Spinner;
